import { useCurrentModule } from '../../ModuleProvider';
export const useSubmitError = _ref => {
  let {
    eventAggregator
  } = _ref;
  const module = useCurrentModule();
  const handleSubmitError = _ref2 => {
    let {
      failureReason,
      error
    } = _ref2;
    const params = {
      eventAggregator,
      failureReason,
      error
    };
    if (failureReason === 'SUBMIT_BUSINESS_ERROR') {
      module.internals.bi.onCheckoutBusinessError == null || module.internals.bi.onCheckoutBusinessError(params);
    }
    if (failureReason === 'SUBMIT_FATAL_ERROR') {
      module.internals.bi.onCheckoutFatalError == null || module.internals.bi.onCheckoutFatalError(params);
    }
    if (failureReason === 'SUBMIT_VALIDATION_ERROR') {
      module.internals.bi.onCheckoutValidationError == null || module.internals.bi.onCheckoutValidationError(params);
    }
  };
  return {
    handleSubmitError
  };
};
//# sourceMappingURL=useSubmitError.js.map